/**
 * Raw event types for activities tracking
 * These are emitted from components before transformation
 */

import { createTrackingEmitterHooks } from "@b2bportal/core-tracking";

export enum ActivitiesRawEventName {
  ActivityViewedInList = "ActivityViewedInList",
  ActivityDetailsViewed = "ActivityDetailsViewed",
  ActivityFiltersApplied = "ActivityFiltersApplied",
  ActivitySearchLoaded = "ActivitySearchLoaded",
}

export type ActivityViewedInListRawEvent = {
  name: ActivitiesRawEventName.ActivityViewedInList;
  properties: {
    productId: string;
    price?: number;
    sortIndex: number;
    sortUsed?: string;
    activity_name: string;
  };
};

export type ActivityDetailsViewedRawEvent = {
  name: ActivitiesRawEventName.ActivityDetailsViewed;
  properties: {
    productId: string;
    activity_name: string;
    avg_rating?: number;
    number_of_reviews?: number;
    number_of_photos: number;
    total_price?: number;
  };
};

export type ActivityFiltersAppliedRawEvent = {
  name: ActivitiesRawEventName.ActivityFiltersApplied;
  properties: {
    filterTypes: string[];
    location?: string;
    categoriesCount?: number;
    priceFilterApplied?: boolean;
    ratingFilterApplied?: boolean;
    timeFilterApplied?: boolean;
    durationFilterApplied?: boolean;
    tagsFilterApplied?: boolean;
  };
};

export type ActivitySearchLoadedRawEvent = {
  name: ActivitiesRawEventName.ActivitySearchLoaded;
};

export type ActivitiesRawEvent =
  | ActivityViewedInListRawEvent
  | ActivityDetailsViewedRawEvent
  | ActivityFiltersAppliedRawEvent
  | ActivitySearchLoadedRawEvent;

export const {
  useEmitRawEvent: useEmitActivitiesRawEvent,
  useEmitRawEventOnce: useEmitActivitiesRawEventOnce,
} = createTrackingEmitterHooks<ActivitiesRawEvent>();
